import React from "react";
import ReactDOM from "react-dom";
import index from "./redux/index";
import "./scss/custom.scss";
import "./scss/index.scss";
import "./fonts/Optima.woff";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import config from "./aws-exports";
import Amplify from "aws-amplify";
Amplify.configure(config);

ReactDOM.render(<App />, document.getElementById("root"));
unregister();
